import i18next from 'i18next'
import React, { useContext, useEffect, useMemo, useState } from 'react'
/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { BoxClass } from '../../../helper/classes'
import {
  Radio,
  RadioGroup,
  UL,
  Switch,
  HTMLTable,
  Card,
  Button,
  Popover,
  Menu,
  MenuItem,
  HTMLSelect
} from '@blueprintjs/core'
import { OverlayProps } from '../../../helper/configs'
import { globalOnDemandVars } from '../../../helper/context'
import { useTranslation } from 'react-i18next'

function PreferencesAddOn () {
  const { t } = useTranslation()
  // const [menuDirection, setMenuDirection] = useState(globalOnDemandVars.insertConfig().sidebarDirection)
  // const context = useContext(GlobalContext)
  // TODO 풀스크린을 크롬 브라우저에서 제어하는걸로 하는건 한계가 있고 어쩔수없어... 즉 esc 누르는 걸로 풀린다는거말임. electron 사용하게 돼서는 거기서 제공되는걸로 풀스크린하게 가능하지않을까??? 그걸로 바꿔야함
  // const [fullScreen, setFullScreen] = useState(globalOnDemandVars.fullScreenBoolean())
  // useEffect(() => {
  //   setFullScreen(globalOnDemandVars.fullScreenBoolean())
  // }, [context.configReady])
  // useEffect(() => {
  //   if (screenfull.isEnabled) {
  //     if (fullScreen) {
  //       screenfull.request()
  //       globalOnDemandVars.set_fullScreenBoolean(true)
  //       setFullScreen(true)
  //     } else {
  //       screenfull.exit()
  //       globalOnDemandVars.set_fullScreenBoolean(false)
  //       setFullScreen(false)
  //     }
  //   }
  // }, [fullScreen, context.configReady])

  const [limitNodeHeight, setLimitNodeHeight] = useState(globalOnDemandVars.limitNodeHeight())

  const currentLanguage = i18next.languages[0]

  return useMemo(() => ((
    <div css={css`width: 100%; padding: 1em;
& .bp3-card {
  display: flex;
  flex-wrap: wrap;
  box-shadow: none !important;
  padding: 0;
}
& .bp3-card > div {
  margin-right: 1em;
}
`}>
      {/* <tr> */}
      {/*  <Switch label='Full Screen' inline alignIndicator={'right'} checked={fullScreen} onChange={() => { */}
      {/*    if (screenfull.isEnabled) { */}
      {/*      setFullScreen(!fullScreen) */}
      {/*    } */}
      {/*  }} /> */}
      {/* </tr> */}
      {/* <Card className={'mini'}> */}
      {/*  <div> */}
      {/*    Menu Direction */}
      {/*  </div> */}
      {/*  <div> */}
      {/*    <RadioGroup */}
      {/*      selectedValue={menuDirection} */}
      {/*      onChange={(e) => { */}
      {/*        globalOnDemandVars.setSidebarDirection()(e.currentTarget.value) */}
      {/*        setMenuDirection(e.currentTarget.value) */}
      {/*      }} */}
      {/*      inline */}
      {/*    > */}
      {/*      <Radio label='left' value='left' /> */}
      {/*      <Radio label='right' value='right' /> */}
      {/*    </RadioGroup> */}
      {/*  </div> */}
      {/* </Card> */}
      {/* <br /> */}
      <Card>
        <div>
          {t('Limit Node Height')}
        </div>
        <div>
          <Switch inline alignIndicator={'right'} checked={limitNodeHeight} onChange={() => {
            const newBool = !limitNodeHeight
            setLimitNodeHeight(newBool)
            globalOnDemandVars.set_limitNodeHeight(newBool)
            globalOnDemandVars.refresh()()
          }} />
        </div>
      </Card>

      <Card>
        <div>
          {t('Change Language')}
        </div>
        <div>
          <HTMLSelect options={[
            {
              label: t('English'),
              value: 'en'
            },
            {
              label: t('Korean'),
              value: 'ko'
            }
          ]} onChange={(e) => {
            const value = e.currentTarget.value
            i18next.changeLanguage(value).then(() => {
              globalOnDemandVars.refresh()()
            })
          }} value={currentLanguage} />
        </div>
      </Card>
      {/* <tr> */}
      {/*  <RadioGroup */}
      {/*    label='Theme' */}
      {/*    onChange={null} */}
      {/*    selectedValue={'light'} */}
      {/*    inline */}
      {/*    disabled */}
      {/*  > */}
      {/*    <Radio label='light' value='light' /> */}
      {/*    <Radio label='dark' value='dark' /> */}
      {/*  </RadioGroup> */}
      {/* </tr> */}
    </div>
  )
  ), [currentLanguage, limitNodeHeight, t])
}

const PreferencesAddOnBoxClass = new BoxClass(PreferencesAddOn, 'Preferences', null, 3, { order: 3 })

export default PreferencesAddOnBoxClass

export { PreferencesAddOn }
